import { me } from '@/api/auth';
import { ApiError } from '@/api/client';
import type { UserPublic } from '@/api/types';

let currentUser: UserPublic | null = null;
let initialized = false;
let useMock = false;

export function mockLogin(user: UserPublic): void {
  currentUser = user;
  initialized = true;
  useMock = true;
}

export function currentSession(): UserPublic | null {
  return currentUser;
}

export function setSessionUser(user: UserPublic | null): void {
  currentUser = user;
  initialized = true;
}

export function isMockMode(): boolean {
  return useMock;
}

export async function ensureSession(): Promise<UserPublic | null> {
  if (initialized) return currentUser;
  try {
    const user = await me();
    currentUser = user;
    useMock = false;
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      currentUser = null;
    } else {
      currentUser = null;
    }
  }
  initialized = true;
  return currentUser;
}

export function clearSession(): void {
  currentUser = null;
  initialized = false;
  useMock = false;
}
